import React,{useEffect, useState} from 'react'
import { useNavigate } from 'react-router-dom';
import { useLocation } from 'react-router-dom';
import { getCookie } from '../../Utils/cookies';
import {showData} from '../../Utils/APIs/commonShowAPI';
import {insertData} from '../../Utils/APIs/commonInsertAPI';
import axios from 'axios';
import { externalDataFetch } from '../../Utils/APIs/externalDataFetchAPI';
const Index = () => {
  const Navigate = useNavigate();
  const [fieldSalesList,setFieldSalesList] = useState([]);
  const [selectedEmployee, setSelectedEmployee] = useState(null);
  const [errorToggle, setErrorToggle] = useState(false);
  const location = useLocation();
  const {_id} = location.state || {};
  const [farmerData, setFarmerData] = useState({});
  const [warehouseData, setWarehouseData] = useState([]);
  const [warehouseId, setWarehouseId] = useState(null);
  const [assignFormResponse, setAssignFormResponse]= useState(null);
  useEffect(() => {
      const token = getCookie('token');
      if(!token){
        Navigate('/');
      } 
    }, []);
    useEffect(()=>{
      showData(`farmer/showSingleFarmer?id=${_id}`,setFarmerData)
    },[_id]);
    
    useEffect(()=>{
      externalDataFetch("http://88.222.214.93:5000/service-team/show-warehouse-persons", setWarehouseData);
    },[])
    
    useEffect(()=>{
      console.log("WarehouseId",warehouseId);
    })

    useEffect(() => {
      (async function fetchFieldSalesData() {
        try {
          const sendRequest = await axios.get(`http://88.222.214.93:5000/service-team/all-service-persons`);
          setFieldSalesList(sendRequest.data.data);
        } catch (error) {
          console.error(error);
        }
      })();
    },[]);

    const assignHandleForm = async(e) =>{
      e.preventDefault();
      if((selectedEmployee === null || selectedEmployee.length < 1) && (warehouseId === null || warehouseId.length < 1)){
        setErrorToggle(true)
      }else{
        setErrorToggle(false)
      }
      const data = {
        "assignFS":selectedEmployee,
        "farmerId":_id,
        "warehouseId" : warehouseId
      }
      // console.log("selectedEmployee",data);
      await insertData('farmer/assignFS',setAssignFormResponse,data) 
      console.log(assignFormResponse)
    }
  return (
    <>
      <div className=" flex flex-col">
        <div>
          <h1 className=' text-3xl font-semibold tracking-widest text-center p-2 bg-gray-900 text-gray-100'>F<span className='text-lg'>ARMER</span> D<span className='text-lg'>ETAILS</span></h1>
        </div>
        <div className="flex flex-row justify-around bg-gray-200 ">
          <h1 className=' text-2xl font-semibold  tracking-widest p-2'>F<span className='text-lg'>armer</span> N<span className='text-lg'>ame - {farmerData.farmerName} </span></h1>
          <h1 className=' text-2xl font-semibold  tracking-widest p-2'>S<span className='text-lg'>aral</span> I<span className='text-lg'>d - {farmerData.saralId}</span></h1>
        </div>
        <div className=" flex flex-row justify-around p-1">
          <div className='mt-3'>
            <table className='text-left'>
              <tr>
                <th>Contact</th>
                <td>: {farmerData?.contact}</td>
              </tr>
              <tr>
                <th>Father Or Husband </th>
                <td>: {farmerData?.fatherOrHusbandName || "N/A"}</td>
              </tr>
              <tr>
                <th>Installation Date </th>
                <td>: {farmerData?.installationDate}</td>
              </tr>
              <tr>
                <th> HP </th>
                <td>: {farmerData?.HP}</td>
              </tr>
              <tr>
                <th>State</th>
                <td>: {farmerData?.state}</td>
              </tr>
              <tr>
                <th>District</th>
                <td>: {farmerData?.district}</td>
              </tr>
              <tr>
                <th> Block </th>
                <td>: {farmerData?.block}</td>
              </tr>
              <tr>
                <th>Gram Panchayat </th>
                <td>: {farmerData?.gram_panchayat}</td>
              </tr>
              <tr>
                <th> Address</th>
                <td>: {farmerData?.address}</td>
              </tr>
              <tr>
                <th>Village</th>
                <td>: {farmerData?.village}</td>
              </tr>
              <tr>
                <th>Pump Type </th>
                <td>: {farmerData?.pump_type}</td>
              </tr>
              <tr>
                <th>AC/DC </th>
                <td>: {farmerData?.AC_DC}</td>
              </tr>
              <tr>
                <th>Department </th>
                <td>: {farmerData?.department}</td>
              </tr>
              <tr>
                <th>Project </th>
                <td>: {farmerData?.project}</td>
              </tr>
              <tr>
                <th>Product </th>
                <td>: {farmerData?.product}</td>
              </tr>
              <tr>
                <th>Longitude </th>
                <td>: {farmerData?.longitude}</td>
              </tr>
              <tr>
                <th>Latitude </th>
                <td>: {farmerData?.latitude}</td>
              </tr>
            </table>
          </div>
          <div>
            <table className='text-left'>
              <tr><th>Field Employee Name</th><td>: {farmerData?.fieldServiceEmpName}</td></tr>
              <tr><th>Installation Survey</th><td>: {(farmerData?.installationSurvey) ? "Done" : "Not Done"}</td></tr>
              <tr><th>Warehouse Person Name</th><td>: {farmerData?.warehousePersonName}</td></tr>
            </table>
          </div>
          <div className='mt-3'>
            <>
              <label for="startDate" className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">Field Service<span className='text-red-500 fixed h-3'>*</span></label>
              <select
                className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-sm  block w-full p-2.5"
                id="state-select"
                value={selectedEmployee}
                onChange={(e) => setSelectedEmployee(e.target.value)}
              >
                <option value="">-- Select Field Sales --</option>
                {fieldSalesList?.map(({ _id, name }) => (
                  <option key={_id} value={_id}>
                    {name}
                  </option>
                ))}
              </select>
            </>
            <>
              {errorToggle && <span className='block text-red-600'> First Choose Field Employee. </span>}
            </>
            <>
            <>
              <label for="startDate" className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">Warehouse<span className='text-red-500 fixed h-3'>*</span></label>
              <select
                className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-sm  block w-full p-2.5"
                id="state-select"
                value={warehouseId}
                onChange={(e) => setWarehouseId(e.target.value)}
              >
                <option value="">-- Select Warehouse --</option>
                {warehouseData?.map(({ _id, name }) => (
                  <option key={_id} value={_id}>
                    {name}
                  </option>
                ))}
              </select>
            </>
            <>
              {errorToggle && <span className='block text-red-600'> First Choose Field Employee. </span>}
              {assignFormResponse && <span className='block text-red-600'> {assignFormResponse} </span>}
            </>
            <></>
            <button 
              type="submit" 
              onClick={assignHandleForm}
              className="text-dark  mt-6 hover:bg-yellow-400 font-medium rounded-sm text-sm w-full sm:w-auto px-5 py-2.5 text-center firstBgColor">
                Assign
            </button>
            </>
          </div>
        </div>    
      </div>
    
    </>
  )
}

export default Index